
import Vue from "vue";
import { authMapGetters } from "@/store/modules/auth";
import { getCompanyLabel } from "../../../helpers/companies";
import { quoteMapState } from "@/store/modules/quote";

export default Vue.extend({
  name: "territory-lookup-select",
  props: {
    territories: {
      type: Array,
      required: false,
      default: () => []
    },
    value: {
      type: String,
      required: false,
      default: ""
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    ...authMapGetters(["getCurrentUser"]),
    ...quoteMapState(["editing"]),
    getCompanies(): any {
      const companies =
        this.getCurrentUser && this.getCurrentUser.companiesData
          ? this.getCurrentUser.companiesData
          : [];
      return companies;
    }
  },
  methods: {
    getTerritory(territory: any) {
      const companyTerritories = territory.territoryInfo.companyTerritories;

      const result = companyTerritories.map(({ companyNumber, terr }: any) => {
        const companyLabel = getCompanyLabel(companyNumber, "", "quote");

        return `${companyLabel} - ${terr}`;
      });

      return result;
    },
    getSeacoastTerritories(territory: any) {
      const companyTerritories = territory.territoryInfo.companyTerritories;

      const result = companyTerritories.map(function({
        isSeaCoast,
        companyNumber,
        seaTerr,
        windTerr
      }: any) {
        if (companyNumber === 31 && windTerr) {
          return `${getCompanyLabel(companyNumber, "", "quote")} - ${windTerr}`;
        }
        return isSeaCoast
          ? `${getCompanyLabel(companyNumber, "", "quote")} - ${seaTerr}`
          : null;
      });
      return result;
    }
  }
});
